import { Ace2ClaimAction, Ace2ClaimActionTypes, Ace2ClaimState } from "./types";

const initialState: Ace2ClaimState = {
  claimId: "",
  statusCode: "",
  plan: {},
  data: {},
  customerId: "",
  customer_data: {},
  warranty_items: [],
  claim_items: [],
  status: "",
  draftModal: {
    isShow: false,
    claimId: null,
  },
  inProcessModal: {
    isShow: false,
    claimStatusCode: null,
  },
  submitErrorModal: {
    isShow: false,
    message: null,
  },
};

export const ace2ClaimReducer = (
  state: Ace2ClaimState = initialState,
  action: Ace2ClaimActionTypes
): Ace2ClaimState => {
  switch (action.type) {
    case Ace2ClaimAction.SET_WARRNTY_ITEMS: {
      return {
        ...state,
        warranty_items: action?.payload || [],
      };
    }

    case Ace2ClaimAction.SET_CLAIM_INFO: {
      return {
        ...state,
        claimId: action?.payload?.claimId || state?.claimId || "",
        status: action?.payload?.status || state?.status || "",
        plan: action?.payload?.plan || state?.plan || {},
        warranty_items:
          action?.payload?.warranty_items || state?.warranty_items || [],
        claim_items: action?.payload?.claim_items || state?.claim_items || [],
        data: action?.payload?.data || state?.data || {},
        customerId: action?.payload?.customerId || state?.customerId || {},
        customer_data:
          action?.payload?.customer_data || state?.customer_data || {},
      };
    }

    case Ace2ClaimAction.CLEAN_UP: {
      return {
        ...state,
        claimId: "",
        plan: {},
        data: {},
        warranty_items: [],
        claim_items: [],
        statusCode: "",
        customer_data: {},
        customerId: "",
        draftModal: { isShow: false, claimId: null },
        inProcessModal: { isShow: false, claimStatusCode: null },
        submitErrorModal: { isShow: false, message: null },
      };
    }

    case Ace2ClaimAction.SET_DRAFT_MODAL: {
      return {
        ...state,
        draftModal: action.payload,
      };
    }

    case Ace2ClaimAction.SET_IN_PROCESS_MODAL: {
      return {
        ...state,
        inProcessModal: action.payload,
      };
    }

    case Ace2ClaimAction.SET_SUBMIT_ERROR_MODAL: {
      return {
        ...state,
        submitErrorModal: action.payload,
      };
    }

    default:
      return state;
  }
};
